var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"title":_vm.title,"variant":_vm.variant},on:{"click":_vm.doClick}},[_c('font-awesome-icon',{attrs:{"icon":"upload"}}),_c('font-awesome-layers',[_c('font-awesome-layers-text',{staticClass:"fa-3x",style:({ backgroundColor: _vm.countColor }),attrs:{"counter":"","value":_vm.files.length,"position":"top-right"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }